import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";

const getSiteAssetReferences = async (siteId) => {
	try {
		let response = await API.get(
			`${Apis.SiteReferences}?siteAssetId=${siteId}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const getSiteAssetReferencesForSite = async (siteId, pageNumber = 1, pageSize = 50, search = "", sortField = "", sortOrder = "") => {
	try {
		const sort = sortField 
			? `&sortField=${sortField}&sortOrder=${sortOrder}`
			: "";
		
		const searchParam = search ? `&search=${search}` : "";
		const pagination = `&pageNumber=${pageNumber}&pageSize=${pageSize}`;
		
		let response = await API.get(
			`${Apis.SiteReferences}/forsite?siteId=${siteId}${pagination}${searchParam}${sort}`
		);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const getSiteAssetReferencesCount = async (siteId, search = "") => {
	try {
		const searchParam = search ? `&search=${search}` : "";
		let response = await API.get(`${Apis.SiteAssetReferencesCount}?siteId=${siteId}${searchParam}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const postSiteAssetReferences = async (data) => {
	try {
		let response = await API.post(`${Apis.SiteReferences}`, data);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const deleteSiteAssetReferences = async (id) => {
	try {
		let response = await API.delete(`${Apis.SiteReferences}/${id}`);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

const updateSiteAssetReferences = async (id, data) => {
	try {
		let response = await API.patch(`${Apis.SiteReferences}/${id}`, data);
		return getAPIResponse(response);
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export {
	getSiteAssetReferences,
	getSiteAssetReferencesForSite,
	getSiteAssetReferencesCount,
	postSiteAssetReferences,
	deleteSiteAssetReferences,
	updateSiteAssetReferences,
};
